import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import slotDefinition from "slotworks/model/slot-definition";

export default class WaysResult extends SymbolWinResult {

    /** For debugging purposes */
    public resultType: string = "WaysResult";

    public waysSymbols: string[][] = [];
    public ways: number;
    /**
     * Cash payout per way
     */
    public perWayPayout: number;
    /**
     * Symbol payout multiplier (as per paytable)
     */
    public multiplier: number;

    /**
     * Takes the WaysResult.waysSymbols and flattens them into a format the rest
     * of the application can easily interpret. In the case where wilds and
     * regular symbols sit within the same reel. We use the more specific
     * symbol.
     *
     * @method flattenWaysSymbols
     */
    public flattenWaysSymbols() {
        this.symbols = [];
        this.waysSymbols.forEach((reel) => {
            if (reel) {
                const nonWild = reel.find((symbol) => !slotDefinition.getSymbolDefinition(symbol).wild);
                const wild = reel.find((symbol) => slotDefinition.getSymbolDefinition(symbol).wild);
                this.symbols.push(nonWild || wild);
            }
        });
    }

}
